import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModelBase } from './PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel */
export interface PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModelType extends Instance<typeof PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel */
// eslint-disable-next-line max-len
export { selectFromPlanningActionMetadataOptimizeOrdersToTargetRoutesDto, planningActionMetadataOptimizeOrdersToTargetRoutesDtoModelPrimitives, PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModelSelector } from './PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel.base';

/**
 * PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel
 */
export const PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModel = PlanningActionMetadataOptimizeOrdersToTargetRoutesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
